"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWhitelabelName = exports.getWhitelabelLogo = exports.getWhitelabelDomain = exports.getPartnerKey = exports.getIsWhitelabel = void 0;

var _environments = require("../../environments");

var getPartnerKey = function getPartnerKey() {
  var _window$PARTNER;

  if ((_window$PARTNER = window.PARTNER) !== null && _window$PARTNER !== void 0 && _window$PARTNER.partnerKey) {
    var _window, _window$PARTNER2;

    return (_window = window) === null || _window === void 0 ? void 0 : (_window$PARTNER2 = _window.PARTNER) === null || _window$PARTNER2 === void 0 ? void 0 : _window$PARTNER2.partnerKey;
  }

  if (_environments.environment.partnerKey) {
    return _environments.environment.partnerKey;
  }

  return undefined;
};

exports.getPartnerKey = getPartnerKey;

var getWhitelabelDomain = function getWhitelabelDomain() {
  var _window$PARTNER3;

  return ((_window$PARTNER3 = window.PARTNER) === null || _window$PARTNER3 === void 0 ? void 0 : _window$PARTNER3.whitelabelDomain) || undefined;
};

exports.getWhitelabelDomain = getWhitelabelDomain;

var getWhitelabelLogo = function getWhitelabelLogo() {
  var _window$PARTNER4, _window$PARTNER5;

  return ((_window$PARTNER4 = window.PARTNER) === null || _window$PARTNER4 === void 0 ? void 0 : _window$PARTNER4.logo) || ((_window$PARTNER5 = window.PARTNER) === null || _window$PARTNER5 === void 0 ? void 0 : _window$PARTNER5.logoMobile) || undefined;
};

exports.getWhitelabelLogo = getWhitelabelLogo;

var getWhitelabelName = function getWhitelabelName() {
  var _window$PARTNER6;

  return ((_window$PARTNER6 = window.PARTNER) === null || _window$PARTNER6 === void 0 ? void 0 : _window$PARTNER6.name) || 'LT';
};

exports.getWhitelabelName = getWhitelabelName;

var getIsWhitelabel = function getIsWhitelabel() {
  return !!window.PARTNER && window.PARTNER.name !== 'LT';
};

exports.getIsWhitelabel = getIsWhitelabel;